import * as React from 'react';

import GridMonthContainer from '../../components/grid/container';
import ListMonthContainer from '../../components/list/container';

import { CalendarContainerProps } from '../../components/calendar-container';
import CalendarViewToggle from '../../components/calendar-view-toggle';
import { CalendarViewMode } from '../../classes/calendar';

import LoaderView from '../../components/loader';


const CalendarContainerView: React.StatelessComponent<CalendarContainerProps> = props => {
    let component: JSX.Element = null;

    if (props.calendarViewMode === CalendarViewMode.GRID) {
        component = <GridMonthContainer />
    } else {
        component = <ListMonthContainer />;
    }
     
    return (
        <>
            <LoaderView />
            {component}
        </>
    )
}

export default CalendarContainerView;